var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 500 500)",
    id: 788452
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 -36.3651 -20.4548)",
    id: 247323
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(115,115,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-46, -47.75)",
    d: "M 15 74.5 v -48.5 c 0 -2.761 2.239 -5 5 -5 h 13 h 12 c 2.761 0 5 2.239 5 5 v 4 h 25 c 1.105 0 2 0.895 2 2 v 8 h -54 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 -0.0015 86.3635)",
    id: 98787
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(115,115,115)",
      fillOpacity: 0.5,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-50, -59.5)",
    d: "M 15 74.667 l 8 -34.667 h 62 l -9 39 h -61",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 -102.7869 0)",
    id: 485631
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(120,162,210)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-38.6936, -50)",
    d: "M 48.346 55 h -21.428 c -0.152 0 -0.296 -0.069 -0.391 -0.188 c -0.095 -0.119 -0.13 -0.275 -0.096 -0.423 l 2.082 -9.002 c 0.052 -0.226 0.254 -0.387 0.487 -0.387 h 21.469 c 0.153 0 0.297 0.07 0.392 0.189 c 0.095 0.12 0.129 0.276 0.095 0.424 l -2.123 9.002 c -0.053 0.226 -0.255 0.385 -0.487 0.385 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 -0.0003 -0.0003)",
    id: 837512
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(43,31,41)",
      fillOpacity: 0.43,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-50.0001, -50)",
    d: "M 76 80 h -61 c -0.552 0 -1 -0.447 -1 -1 v -53 c 0 -3.309 2.691 -6 6 -6 h 25 c 3.309 0 6 2.691 6 6 v 3 h 24 c 1.654 0 3 1.346 3 3 v 7 h 7 c 0.305 0 0.593 0.139 0.783 0.378 c 0.189 0.238 0.26 0.55 0.192 0.847 l -9 39 c -0.105 0.454 -0.509 0.775 -0.975 0.775 z M 16 78 h 59.205 l 8.539 -37 h -59.949 l -7.795 33.781 z M 20 22 c -2.206 0 -4 1.794 -4 4 v 39.887 l 6.025 -26.111 c 0.105 -0.455 0.509 -0.776 0.975 -0.776 h 53 v -7 c 0 -0.552 -0.449 -1 -1 -1 h -25 c -0.552 0 -1 -0.447 -1 -1 v -4 c 0 -2.206 -1.794 -4 -4 -4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 -159.0923 -190.9091)",
    id: 910391
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(43,31,41)",
      fillOpacity: 0.43,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-32.5, -29)",
    d: "M 46.5 30 c -0.276 0 -0.5 -0.224 -0.5 -0.5 v -3.5 c 0 -0.552 -0.449 -1 -1 -1 h -0.5 c -0.276 0 -0.5 -0.224 -0.5 -0.5 c 0 -0.276 0.224 -0.5 0.5 -0.5 h 0.5 c 1.103 0 2 0.897 2 2 v 3.5 c 0 0.276 -0.224 0.5 -0.5 0.5 z M 41.5 25 h -2 c -0.276 0 -0.5 -0.224 -0.5 -0.5 c 0 -0.276 0.224 -0.5 0.5 -0.5 h 2 c 0.276 0 0.5 0.224 0.5 0.5 c 0 0.276 -0.224 0.5 -0.5 0.5 z M 18.5 34 c -0.276 0 -0.5 -0.224 -0.5 -0.5 v -7.5 c 0 -1.103 0.897 -2 2 -2 h 16.5 c 0.276 0 0.5 0.224 0.5 0.5 c 0 0.276 -0.224 0.5 -0.5 0.5 h -16.5 c -0.551 0 -1 0.448 -1 1 v 7.5 c 0 0.276 -0.224 0.5 -0.5 0.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 -102.7869 0)",
    id: 894877
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(43,31,41)",
      fillOpacity: 0.43,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-38.6936, -50)",
    d: "M 48.346 55 h -21.428 c -0.152 0 -0.296 -0.069 -0.391 -0.188 c -0.095 -0.119 -0.13 -0.275 -0.096 -0.423 l 2.082 -9.002 c 0.052 -0.226 0.254 -0.387 0.487 -0.387 h 11.5 c 0.276 0 0.5 0.223 0.5 0.499 c 0 0.276 -0.224 0.499 -0.5 0.499 h -11.102 l -1.851 8.004 h 20.403 l 1.887 -8.004 h -1.837 c -0.276 0 -0.5 -0.223 -0.5 -0.499 c 0 -0.276 0.223 -0.499 0.5 -0.499 h 2.469 c 0.153 0 0.297 0.07 0.392 0.189 c 0.095 0.12 0.129 0.276 0.095 0.424 l -2.123 9.002 c -0.053 0.226 -0.255 0.385 -0.487 0.385 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 -50.0012 -40.9091)",
    id: 869401
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(43,31,41)",
      fillOpacity: 0.43,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-44.5, -45.5)",
    d: "M 45.5 46 h -2 c -0.276 0 -0.5 -0.224 -0.5 -0.5 c 0 -0.276 0.224 -0.5 0.5 -0.5 h 2 c 0.276 0 0.5 0.224 0.5 0.5 c 0 0.276 -0.224 0.5 -0.5 0.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5511 0 0 3.5511 -10.8702 160.9509)",
    id: 140156
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillOpacity: 0.5,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-124.16, -172.544)",
    d: "M 61.195 161.229 h 3.93 v 25.65 c 0 4.42 -2.00333 6.63 -6.01 6.63 v 0 c -0.86667 0 -1.66667 -0.13 -2.4 -0.39 v 0 v -3.14 c 0.45333 0.11333 1.04667 0.17 1.78 0.17 v 0 c 0.88 0 1.55 -0.23667 2.01 -0.71 c 0.46 -0.47333 0.69 -1.3 0.69 -2.48 v 0 z M 60.795 155.129 v 0 c 0 -0.62667 0.19333 -1.16333 0.58 -1.61 c 0.39333 -0.44 0.96333 -0.66 1.71 -0.66 v 0 c 0.76667 0 1.35 0.21667 1.75 0.65 c 0.39333 0.44 0.59 0.98 0.59 1.62 c 0 0.64 -0.19667 1.17 -0.59 1.59 c -0.4 0.42667 -0.98333 0.64 -1.75 0.64 c -0.76 0 -1.33333 -0.21333 -1.72 -0.64 c -0.38 -0.42 -0.57 -0.95 -0.57 -1.59 z M 89.775 184.219 h -4.12 c -0.22667 -0.45333 -0.41 -1.26 -0.55 -2.42 v 0 c -1.82667 1.9 -4.01 2.85 -6.55 2.85 v 0 c -2.26667 0 -4.12333 -0.64333 -5.57 -1.93 c -1.45333 -1.28 -2.18 -2.90333 -2.18 -4.87 v 0 c 0 -2.4 0.91 -4.26 2.73 -5.58 c 1.82 -1.32667 4.38 -1.99 7.68 -1.99 v 0 h 3.83 v -1.81 c 0 -1.37333 -0.41333 -2.46667 -1.24 -3.28 c -0.82 -0.81333 -2.03 -1.22 -3.63 -1.22 v 0 c -1.4 0 -2.57667 0.35333 -3.53 1.06 c -0.94667 0.70667 -1.42 1.56333 -1.42 2.57 v 0 h -3.95 c 0 -1.14667 0.40667 -2.25333 1.22 -3.32 c 0.81333 -1.07333 1.91667 -1.92 3.31 -2.54 c 1.39333 -0.62667 2.92667 -0.94 4.6 -0.94 v 0 c 2.65333 0 4.73 0.66333 6.23 1.99 c 1.5 1.32667 2.28 3.15 2.34 5.47 v 0 v 10.58 c 0 2.11333 0.26667 3.79333 0.8 5.04 v 0 z M 79.135 181.219 v 0 c 1.23333 0 2.4 -0.31667 3.5 -0.95 c 1.10667 -0.64 1.91 -1.47 2.41 -2.49 v 0 v -4.72 h -3.09 c -4.81333 0 -7.22 1.41 -7.22 4.23 v 0 c 0 1.23333 0.41 2.19667 1.23 2.89 c 0.82 0.69333 1.87667 1.04 3.17 1.04 z M 103.315 169.469 v 3.21 h -10.37 v -3.21 z M 106.095 172.789 v -0.28 c 0 -2.25333 0.44333 -4.28 1.33 -6.08 c 0.88667 -1.79333 2.12 -3.18 3.7 -4.16 c 1.58 -0.98 3.38333 -1.47 5.41 -1.47 v 0 c 3.12667 0 5.65667 1.08333 7.59 3.25 c 1.94 2.17333 2.91 5.05667 2.91 8.65 v 0 v 0.28 c 0 2.24 -0.43 4.24667 -1.29 6.02 c -0.86 1.78 -2.08667 3.16667 -3.68 4.16 c -1.59333 0.99333 -3.42333 1.49 -5.49 1.49 v 0 c -3.11333 0 -5.64 -1.08667 -7.58 -3.26 c -1.93333 -2.16667 -2.9 -5.03333 -2.9 -8.6 z M 110.055 172.979 v 0 c 0 2.54667 0.59 4.59333 1.77 6.14 c 1.18667 1.54667 2.77 2.32 4.75 2.32 v 0 c 2 0 3.58667 -0.78333 4.76 -2.35 c 1.17333 -1.56667 1.76 -3.76 1.76 -6.58 v 0 c 0 -2.52 -0.59667 -4.56333 -1.79 -6.13 c -1.2 -1.56667 -2.79 -2.35 -4.77 -2.35 v 0 c -1.94 0 -3.50667 0.77333 -4.7 2.32 c -1.18667 1.54667 -1.78 3.75667 -1.78 6.63 z M 131.005 172.829 v -0.3 c 0 -3.52667 0.83667 -6.36333 2.51 -8.51 c 1.66667 -2.14667 3.85333 -3.22 6.56 -3.22 v 0 c 2.69333 0 4.82667 0.92333 6.4 2.77 v 0 v -11.99 h 3.93 v 32.64 h -3.61 l -0.19 -2.47 c -1.57333 1.93333 -3.76333 2.9 -6.57 2.9 v 0 c -2.66 0 -4.83 -1.09333 -6.51 -3.28 c -1.68 -2.18 -2.52 -5.02667 -2.52 -8.54 z M 134.935 172.979 v 0 c 0 2.60667 0.54 4.64667 1.62 6.12 c 1.07333 1.47333 2.56 2.21 4.46 2.21 v 0 c 2.49333 0 4.31333 -1.12 5.46 -3.36 v 0 v -10.56 c -1.17333 -2.16667 -2.98 -3.25 -5.42 -3.25 v 0 c -1.92667 0 -3.42667 0.74333 -4.5 2.23 c -1.08 1.48667 -1.62 3.69 -1.62 6.61 z M 170.785 184.219 l -0.09 -2.27 c -1.52667 1.8 -3.77 2.7 -6.73 2.7 v 0 c -2.45333 0 -4.32 -0.71333 -5.6 -2.14 c -1.28 -1.42667 -1.93 -3.53333 -1.95 -6.32 v 0 v -14.96 h 3.94 v 14.85 c 0 3.48667 1.41667 5.23 4.25 5.23 v 0 c 3 0 4.99667 -1.12 5.99 -3.36 v 0 v -16.72 h 3.93 v 22.99 z M 191.605 161.099 v 3.66 c -0.59333 -0.1 -1.23667 -0.15 -1.93 -0.15 v 0 c -2.58 0 -4.33 1.09667 -5.25 3.29 v 0 v 16.32 h -3.93 v -22.99 h 3.83 l 0.06 2.65 c 1.28667 -2.05333 3.11333 -3.08 5.48 -3.08 v 0 c 0.76667 0 1.34667 0.1 1.74 0.3 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/logo-gray.ff43637b0d299afa5cf2edc682a95278.svg";
export { ForwardRef as ReactComponent };